import type { TCountry } from '@shared/types/country';
import type { TImage } from '@shared/types/image';
import type { TOrganization } from '@shared/types/organization';
import type { ValueOf } from '@shared/types/utilities';
import type { TUser } from '@shared/types/user';
import type { TMember } from '@shared/types/member';

export const PROGRAM_STATUSES = {
  active: 'ACTIVE',
  inActive: 'IN_ACTIVE',
  archived: 'ARCHIVED',
  draft: 'DRAFT',
} as const;

export const PROGRAM_TYPES = {
  longTerm: 'LONG_TERM',
  shortTerm: 'SHORT_TERM',
} as const;

export type TProgram = {
  id: number;
  creator: number;
  organization: TOrganization;
  name: string;
  description: string;
  logo: string;
  price: string;
  price_currency: string;
  start_date: string;
  deadline: string;
  country: TCountry;
  status: ValueOf<typeof PROGRAM_STATUSES>;
  type: ValueOf<typeof PROGRAM_TYPES>;
  formatted_sharable_uid: string;
  images: TImage[];
  is_free: boolean;
  all_year: boolean;
  is_applied: boolean;
  submission_id: number;
};

export type TProgramWithSubmission = {
  id: number;
  creator: TUser;
  organization: TOrganization;
  country: TCountry;
  images: TImage[];
  has_submission: boolean;
  submission_id: number;
  submission_status: string;
  no_responses: number;
  no_stages: number;
  created_at: string;
  updated_at: string;
  sharable_uid: string;
  formatted_sharable_uid: string;
  name: string;
  description: string;
  status: ValueOf<typeof PROGRAM_STATUSES>;
  type: ValueOf<typeof PROGRAM_TYPES>;
  logo: string;
  price_currency: string;
  price: string;
  start_date: string;
  deadline: string;
  stages_number: number;
  responses: number;
  is_free: boolean;
  all_year: boolean;
  member: TMember;
};
